export function getOfferDetailsFormLabel(fieldname: string): string {
  switch (fieldname) {
    case 'offerNumber':
      return 'offer-detail.form.offer-number';
    case 'name':
      return 'offer-detail.form.name';
    case 'description':
      return 'offer-detail.form.description';
    case 'customer':
      return 'offer-detail.form.customer';
    case 'industries':
      return 'offer-detail.form.industry';
    case 'streetName':
      return 'offer-detail.form.address';
    case 'addressSupplement':
      return 'offer-detail.form.address2';
    case 'zipCode':
      return 'offer-detail.form.zip';
    case 'location':
      return 'offer-detail.form.city';
    case 'country':
      return 'offer-detail.form.country';
    default:
      return fieldname;
  }
}
